<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <OfferForm
          v-model="offer"
          title="Nová nabídka"
          :edit="false"
          :loading="loading"
          :saving="saving"
          @save="save"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import OfferForm from '../../../components/forms/OfferForm'

export default {
  name: 'OfferAdd',
  components: {
    OfferForm,
  },
  data() {
    return {
      offer: {},
      loading: false,
      saving: false,
    }
  },
  methods: {
    ...mapActions({
      createOffer: 'offer/createOffer',
    }),
    save(data) {
      this.saving = true
      this.createOffer({
        offer: this.offer,
        banner: data.bannerFiles,
        customer: data.customerFiles,
        attachments: data.attachmentsFiles,
      })
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            this.$router.push({
              name: 'personalized-offer.detail',
              params: { offerId: response.data.id },
            })
          }
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>
